



























import {Component, Vue} from "vue-property-decorator";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import PasswordlessService, {clearUrlFragment} from "@/components/domains/auth/passwordlessService";
import {toAuthError, tokenFromHash} from "@/components/domains/auth/authPolicy";
import {AuthGetterTypes, AuthMutationTypes} from "@/store/auth/types";

const NO_TOKEN = 'このリンクは使えません。もう一度、メールアドレスの設定からやり直してください。';

/**
 * Landing page of the mailed confirmation link (`/mail-address/confirm#token=…`).
 * Works signed out and confirms on open (the token only adds an address).
 */
@Component({
  components: {DefaultTemplate}
})
export default class MailAddressConfirm extends Vue {
  name = "MailAddressConfirm";

  phase: 'working' | 'done' | 'failed' = 'working';
  mailAddress = '';
  errorMsg = '';

  mounted(): void {
    this.confirm();
    window.addEventListener('hashchange', this.confirm);
  }

  beforeDestroy(): void {
    window.removeEventListener('hashchange', this.confirm);
  }

  async confirm(): Promise<void> {
    const token = tokenFromHash(window.location.hash);
    clearUrlFragment();
    if (!token) {
      if (this.phase === 'working') {
        this.errorMsg = NO_TOKEN;
        this.phase = 'failed';
      }
      return;
    }
    this.phase = 'working';
    try {
      this.mailAddress = await PasswordlessService.confirmMailAddress(token);
    } catch (e) {
      this.errorMsg = toAuthError(e, NO_TOKEN).message;
      this.phase = 'failed';
      return;
    }
    // Signed in in this tab already: hide the "please set an address" notice.
    if (this.$store.getters[AuthGetterTypes.getIsAuthenticated] && this.mailAddress) {
      const current = this.$store.getters[AuthGetterTypes.getCurrentUser];
      this.$store.commit(AuthMutationTypes.setCurrentUser, Object.assign({}, current, {email: this.mailAddress}));
    }
    this.phase = 'done';
  }
}
